class ApiQueue {
  constructor(callback) {
    this.callback = callback;
    this.operations = [];
    this.busy = false;
  }

  addOperation(operation) {
    if (this.busy) {
      this.operations.push(operation);
    } else {
      this.busy = true;
      this.startQueueOpeartion(operation);
    }
  }

  async startQueueOpeartion(operation) {
    var me = this;
    console.log("operation-------", operation);
    let url =
      `/api/documentUpload/getMailingTypeList?searchText=` +
      operation.extraParameter.searchText;
    let options = {
      headers: {
        token: operation.extraParameter.token,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        me.operationFinished();
        me.callback("SUCCESS", json.mailingTypeList, operation.extraParameter);
      })
      .catch((error) => {
        console.log("error-------------", error);
        me.operationFinished();
        me.callback("ERROR", error);
      });
  }

  operationFinished() {
    if (this.operations && this.operations.length > 0) {
      this.startQueueOpeartion(this.operations.shift());
    } else {
      this.busy = false;
    }
  }

  removeAllOperation() {
    this.operations = [];
  }
}
export default ApiQueue;



//////////////////
// WEBPACK FOOTER
// ./utils/api-queue.js
// module id = 1317
// module chunks = 0